import { useContext, useMemo } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { makeUserHasGroupAccess } from '../../../helpers';

export default function useUserHasGroupAccess() {
    const authContext = useContext(AuthContext);
    return useMemo(() => makeUserHasGroupAccess(authContext.user?.groups ?? []), [authContext.user?.groups]);
}
